export default "__VITE_ASSET__Drik83Xq__"